import { MinuteInfo } from 'owa-fps-types';

let internalState: { buffer: MinuteInfo[]; length: number } = { buffer: [], length: 0 };

/**
 * Add a new MinuteInfo.
 * @param avgFps The average framerate in FPS of the past minute.
 * @param wasTabInBackground Whether the document was visible in this minute.
 */
export function addMinuteInfo(avgFps: number, wasTabInBackground: boolean) {
    // Reuse the existing object if it exists; otherwise, allocate one. Since we
    // recycle objects to avoid GCs, we'll end up only allocating new frames
    // when we have a minute that's more performant than any other prior minute
    // in this session
    internalState.buffer[internalState.length] = internalState.buffer[internalState.length] || {
        avgFps: 0,
        wasTabInBackground: false,
    };
    internalState.buffer[internalState.length].avgFps = avgFps;
    internalState.buffer[internalState.length].wasTabInBackground = wasTabInBackground;
    internalState.length++;
}

/**
 * Clear the buffer.
 */
export function flushMinuteInfo() {
    // Set the length back to 1, so that we continue adding from the right
    // point in the array.
    internalState.length = 0;
}

/**
 * Return the buffer and the current length.
 *
 * **WARNING:** because the buffer is recycled, it may contain garbage at
 * indices after the current length
 */
export function getMinuteInfo() {
    return internalState;
}

/**
 * Set the buffer to a new value.
 *
 * Used primarily for testing, as it causes a GC.
 * @param resetValue The value to use to set the buffer
 */
export function resetMinuteInfo(resetValue: MinuteInfo[] = []) {
    internalState.buffer = resetValue;
    internalState.length = resetValue.length;
}

export type MinuteInfoBuffer = typeof internalState;
